/**
 * Check if a user is currently logged in by verifying localStorage data
 * @returns {boolean} True if user is logged in, false otherwise
 */
export const isLoggedIn = () => {
  const employeeId = localStorage.getItem('employeeId');
  const employee = localStorage.getItem('employee');
  
  if (!employeeId || !employee) {
    return false;
  }

  try {
    JSON.parse(employee); // Validate that employee data is valid JSON
    return true;
  } catch (error) {
    console.error('Invalid employee data in localStorage');
    localStorage.removeItem('employeeId');
    localStorage.removeItem('employee');
    return false;
  }
};

/**
 * Get the current employee's ID
 * @returns {string|null} The employee ID if logged in, null otherwise
 */
export const getEmployeeId = () => {
  return localStorage.getItem('employeeId');
};

/**
 * Get the current employee's data
 * @returns {Object|null} The employee data if logged in, null otherwise
 */
export const getEmployee = () => {
  const employee = localStorage.getItem('employee');
  if (!employee) return null;
  
  try {
    return JSON.parse(employee);
  } catch (error) {
    console.error('Invalid employee data in localStorage');
    localStorage.removeItem('employeeId');
    localStorage.removeItem('employee');
    return null;
  }
}; 